// extracted by mini-css-extract-plugin
export var container = "_88-0";